<template>
    <!-- 应收调整行列表 -->
    <vReceivableAdjustmentLineList :postList="postList" v-if="flag"></vReceivableAdjustmentLineList>
</template>
<script>
import vReceivableAdjustmentLineList from '../../listComponent/basicdata/receivableAdjustmentLine/receivableAdjustmentLineComponent.vue';
export default {
    name: 'receivableAdjustmentLineList',
    components: {
        vReceivableAdjustmentLineList
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>